import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import LoadingRoute from './LoadingRoute';
import config from 'config';

// project imports
import { CheckAuth } from 'utils/User';
import { listenChannels } from 'utils/Pusher';

// ==============================|| ROUTING RENDER ||============================== //

ThemeRoutes.propTypes = {
    IsAuth: PropTypes.bool
};

export default function ThemeRoutes({}) {
    const [curRoute, setCurRoute] = useState(LoadingRoute);

    useEffect(() => {
        const fetchData = async () => {
            const isAuth = await CheckAuth();
            if (isAuth) listenChannels();
            setCurRoute(isAuth ? MainRoutes : AuthenticationRoutes);
        };

        fetchData();
    }, []);

    return useRoutes([curRoute], config.basename);
}
